/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Dialog_TitleInputs */

const en_search_dialog_title = /** @type {(inputs: Search_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search the API catalog`)
};

const zh_hans1_search_dialog_title = /** @type {(inputs: Search_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索 API 目录`)
};

const pt_br2_search_dialog_title = /** @type {(inputs: Search_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar no catálogo de APIs`)
};

const es_search_dialog_title = /** @type {(inputs: Search_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar en el catálogo de APIs`)
};

const fr_search_dialog_title = /** @type {(inputs: Search_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher dans le catalogue d’API`)
};

const de_search_dialog_title = /** @type {(inputs: Search_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Katalog durchsuchen`)
};

const ru_search_dialog_title = /** @type {(inputs: Search_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск по каталогу API`)
};

const it_search_dialog_title = /** @type {(inputs: Search_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca nel catalogo di API`)
};

/**
* | output |
* | --- |
* | "Search the API catalog" |
*
* @param {Search_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_dialog_title = /** @type {((inputs?: Search_Dialog_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Dialog_TitleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_dialog_title(inputs)
	if (locale === "pt-BR") return pt_br2_search_dialog_title(inputs)
	if (locale === "es") return es_search_dialog_title(inputs)
	if (locale === "fr") return fr_search_dialog_title(inputs)
	if (locale === "de") return de_search_dialog_title(inputs)
	if (locale === "ru") return ru_search_dialog_title(inputs)
	if (locale === "it") return it_search_dialog_title(inputs)
	return en_search_dialog_title(inputs)
});